export default {

  // 접속한 계정에 노출되는 메뉴 리스트
  list:[],
  // 메뉴 검색
  search:'',

  pageTitle: '',
  pagePath:[],

  // 사용가능한 boardIds, 대시보드 표기 여부를 판단하기 위해 사용하고 있음.
  availableBoardIds: [],

  // 작성페이지 입력 여부
  // writeOldForm 와 writeForm 를 비교하여, 메뉴 클릭시 _blank 로 열릴지 여부를 판단한다.
  writeForm: undefined,
  writeOldForm: undefined,

  // 메인화면에서 노출되는 팝업 리스트
  modalItems: [],
}
